// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"16":"07993fe1ff2c167b","153":"15ace33180466bd1","193":"4a3eacc713857189","198":"1b2f0bd43016d0cc","207":"1e097eb91aa1e5d4","435":"a28195f6cb8c1d76","449":"869ad6341adb2eec","675":"5c3d74f37f0cdee1","918":"5b487e2be6e99236"}[chunkId] + ".js";
};